import { getAssociatedTokenAddressSync } from "@solana/spl-token";
import { PublicKey, TransactionInstruction } from "@solana/web3.js";
import BN from "bn.js";
import { ReferralProgram, StakingAccount } from "../type";
import { deriveStakingAuthority } from "../pda";

export interface IClaimPenaltyFeeParams {
  referralProgram: ReferralProgram;
  stakingAddress: PublicKey;
  stakingAccount: StakingAccount;
  maxAmount: BN;
}

export async function createClaimPenaltyFeeIx(
  params: IClaimPenaltyFeeParams,
): Promise<TransactionInstruction> {
  const { referralProgram, stakingAddress, stakingAccount, maxAmount } = params;

  const feeReceiverTokenAccount = getAssociatedTokenAddressSync(
    stakingAccount.tokenMint,
    stakingAccount.config.feeReceiver,
    true,
  );

  return referralProgram.methods
    .claimPenaltyFee({
      maxAmount,
      padding0: Array(8).fill(new BN(0)),
    })
    .accountsPartial({
      staking: stakingAddress,
      tokenVault: stakingAccount.tokenVault,
      tokenMint: stakingAccount.tokenMint,
      feeReceiverTokenAccount,
      stakingAuthority: deriveStakingAuthority(referralProgram.programId),
    })
    .instruction();
}
